// Stripe product and price configuration for Vesper
// 注意：這些是回退值，實際價格應從資料庫 subscription_plans 表讀取
export const STRIPE_CONFIG = {
  products: {
    basic: {
      id: "prod_TgIT84eecEEtHh",
      name: "Basic",
      monthly: {
        priceId: "price_1Sivt2B3w0CxBOFr0N3quemF",
        amount: 9.90,  // 與資料庫同步
      },
      yearly: {
        priceId: "price_1SivtHB3w0CxBOFrdAB7d3Ff",
        amount: 95.04,  // 9.90 * 12 * 0.8 = 95.04
        monthlyEquivalent: 7.92,  // 95.04 / 12
      },
    },
    pro: {
      id: "prod_TgIUVK10X2IYhW",
      name: "Pro",
      monthly: {
        priceId: "price_1SivtUB3w0CxBOFrhfAHm4o3",
        amount: 12,  // 與資料庫同步
      },
      yearly: {
        priceId: "price_1SivteB3w0CxBOFrBpEn3xtO",
        amount: 115.20,  // 12 * 12 * 0.8 = 115.20
        monthlyEquivalent: 9.60,  // 115.20 / 12
      },
    },
  },
  // Map price IDs to plans for quick lookup
  priceToProduct: {
    "price_1Sivt2B3w0CxBOFr0N3quemF": { plan: "basic", cycle: "monthly" },
    "price_1SivtHB3w0CxBOFrdAB7d3Ff": { plan: "basic", cycle: "yearly" },
    "price_1SivtUB3w0CxBOFrhfAHm4o3": { plan: "pro", cycle: "monthly" },
    "price_1SivteB3w0CxBOFrBpEn3xtO": { plan: "pro", cycle: "yearly" },
  },
} as const;

export type SubscriptionPlan = "free" | "basic" | "pro";
export type BillingCycle = "monthly" | "yearly";

export interface SubscriptionData {
  subscribed: boolean;
  plan: SubscriptionPlan;
  billing_cycle?: BillingCycle;
  status: string;
  current_period_end?: string;
  cancel_at_period_end?: boolean;
}

export const getPriceId = (plan: "basic" | "pro", cycle: BillingCycle): string => {
  return STRIPE_CONFIG.products[plan][cycle].priceId;
};

export const getPlanLimits = (plan: SubscriptionPlan) => {
  switch (plan) {
    case "pro":
      return {
        maxScripts: Infinity,
        maxCharactersPerScript: Infinity,
        hasMirrorMode: true,
        hasCustomFonts: true,
        hasExport: true,
        hasNoWatermark: true,
        hasVoiceSync: true,
        hasOfflineMode: true,
        hasPrioritySupport: true,
      };
    case "basic":
      return {
        maxScripts: 20,
        maxCharactersPerScript: 5000,
        hasMirrorMode: true,
        hasCustomFonts: true,
        hasExport: true,
        hasNoWatermark: true,
        hasVoiceSync: false,
        hasOfflineMode: false,
        hasPrioritySupport: false,
      };
    default:
      return {
        maxScripts: 3,
        maxCharactersPerScript: 1000,
        hasMirrorMode: false,
        hasCustomFonts: false,
        hasExport: false,
        hasNoWatermark: false,
        hasVoiceSync: false,
        hasOfflineMode: false,
        hasPrioritySupport: false,
      };
  }
};
